export default __webpack_public_path__ + "static/media/fin-option-active.1d5ab75e.svg";